// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cancel_button {\n  margin-right: 20px; }\n\n.Notice-content {\n  height: 100%;\n  display: block; }\n", "",{"version":3,"sources":["webpack://src/components/account/style.scss"],"names":[],"mappings":"AAAA;EACG,kBAAkB,EAAA;;AAGrB;EACG,YAAY;EACZ,cAAa,EAAA","sourcesContent":[".cancel_button{\n   margin-right: 20px;\n}\n\n.Notice-content {\n   height: 100%;\n   display:block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
